<template>
  <div class="feedback-wrapper">
     <section class="feedback-header">
        <h3>Feedback</h3>
        <p>Please share your valuable feedback to help us improve our service.</p>
     </section>
     <section class="feedback-body" v-if="feedback">
        <h3 class="m-b-30">Question {{b}}/{{questionsWithChoices.length}}</h3>
        <single-feedback-question-and-choices v-for="question in questionsWithChoices.slice(a, b)" v-bind:key="question.id" :question-with-choices="question"/>
     </section>
     <section class="thank-you" v-if="thankYou">
       <h2>
         Thank you for your response.
       </h2>
     </section>
     <section class="feedback-footer">
       <b-row>
         <b-col cols="6">
           <b-btn variant="default" @click="skipQuestion">Skip</b-btn>
         </b-col>
          <b-col cols="6">
           
           <b-btn variant="primary"  class="float-right" @click="nextQuestion">Next</b-btn>
           <b-btn variant="outline-primary"  class="float-right m-r-10" @click="backOneStep">Back</b-btn>
         </b-col>
       </b-row>
     </section>
  </div>
</template>

<script>
const SingleFeedbackQuestionAndChoices = () => import(/* webpackChunkName: "single-feedback-question-and-choices" */ './single-feedback-question-and-choices')
import CustomerFeedbackService from '../../services/customer-feedback.service';
  export default {
     data(){
       return {
         questionsWithChoices: [],
         a: 0,
         b: 1,
         feedback: true,
         thankYou: false
       }
     },
     components: {SingleFeedbackQuestionAndChoices},
     mounted(){
       document.body.style.backgroundColor = `#f0f2f5`;
       this.fetchQuestionsWithOptions()
     },
     methods: {
       async fetchQuestionsWithOptions(){
         try{
           const result = await CustomerFeedbackService.fetchQuestionsWithChoices();
           this.questionsWithChoices = result.data.questionsWithChoices
         }catch(errors){
           console.log(errors.response.data)
         }
       },
       nextQuestion(){
        if(this.questionsWithChoices.length - 1 == this.a) {
          this.thankYou = true;
          this.feedback = false;
        }else{
          this.a++;
          this.b++;
        }
        
      },
      backOneStep(){
        if(this.a !== 0){
          this.a--;
          this.b--;
        }
      },
      skipQuestion(){
        if(this.questionsWithChoices.length - 1 == this.a) {
          this.thankYou = true;
          this.feedback = false;
        }else{
          this.a++;
          this.b++;
        }
      }
     },
     
  }
</script>

<style lang="scss" scoped>
  .feedback-wrapper{
    max-width: 620px;
    margin: 30px auto;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .1), 0 8px 16px rgba(0, 0, 0, .1);
  }
  .feedback-header{
    padding: 25px 25px 10px 25px;
  }
  .feedback-header{
    border-bottom: 1px solid rgb(236, 236, 236);
  }
  .feedback-footer, .feedback-body, .thank-you{
    padding: 25px;
  }
</style>